import script from "./layoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./layoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./layoutHeader.vue?vue&type=style&index=0&id=319d7bbc&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319d7bbc"]])

export default __exports__